<template>
  <div id="app" @mousedown="displayGradeList(false)">
    <div id="stage-outer">
      <div id="stage">
        <viewerArea></viewerArea>
        <extBtn v-if="!isTabletMode"></extBtn>
        <featureDetail></featureDetail>
        <featureSwitch v-if="!isTabletMode"></featureSwitch>
        <bottomMenu></bottomMenu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import './common.css';
import bottomMenu from './components/bottomMenu'
import viewerArea from './components/viewerArea'
import featureDetail from './components/featureDetail'
import extBtn from './components/extBtn'
import featureSwitch from './components/featureSwitch'

export default {
  name: 'app',
  components: {
    bottomMenu,
    viewerArea,
    featureDetail,
    extBtn,
    featureSwitch,
  },
  computed: {
    ...mapState([
      'isTabletMode'
    ]),
  },
  methods:{
    ...mapActions([
      'displayGradeList'
    ]),
  },
  mounted: function(){
    this.$store.dispatch('setData');
  }
}
</script>

<style lang="scss" scoped>
#app{
  width: 100%;
  height: 100%;
  background: #282828;
  // display: table;
  min-width: 1024px;
  min-height: 765px;
}
#stage-outer{
  // display: table-cell;
  // vertical-align: middle;
  height: 100%;
}
#stage{
  width: 100%;
  height: 100%;
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
}
</style>
  